const constants = {
  API_URL_PRESIGNUP: '/auth/keys',
  API_URL_SIGNUP: '/auth/signup',
  API_URL_PRESIGNIN: '/auth/keys/',
  API_URL_SIGNIN: '/auth/signin',
  API_URL_RESET: '/auth/reset',
  API_URL_CODE: '/auth/sendResetCode',

  API_URL_BOOKMARK: '/bookmark',
  API_URL_BOOKMARK_IMPORT: '/bookmark/import',
  API_URL_MAIL: '/bookmark/sendExportMail',
  API_URL_PREFERENCES: '/user/preferences',
  API_URL_USER_DETAILS: '/user/details',

  API_URL_NOTE: '/note',
};

export default constants;
